import { render, staticRenderFns } from "./JGridCtrl.vue?vue&type=template&id=458fb17f"
import script from "./JGridCtrl.vue?vue&type=script&lang=js"
export * from "./JGridCtrl.vue?vue&type=script&lang=js"
import style0 from "./JGridCtrl.vue?vue&type=style&index=0&id=458fb17f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports